// src/hooks/useRoles.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export const useRoles = () => {
  const queryClient = useQueryClient();

  const { data: roles = [], isLoading, error, refetch } = useQuery({
    queryKey: ['roles'],
    queryFn: async () => {
      const response = await api.get('/roles');
      return response.data;
    }
  });

  const createRoleMutation = useMutation({
    mutationFn: async (roleData) => {
      const response = await api.post('/roles', roleData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['roles']);
    }
  });

  const updateRoleMutation = useMutation({
    mutationFn: async ({ roleId, roleData }) => {
      const response = await api.put(`/roles/${roleId}`, roleData);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['roles']);
    }
  });

  const deleteRoleMutation = useMutation({
    mutationFn: async (roleId) => {
      await api.delete(`/roles/${roleId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['roles']);
    }
  });

  return {
    roles,
    isLoading,
    error,
    refetch,
    createRole: createRoleMutation.mutateAsync,
    updateRole: updateRoleMutation.mutateAsync,
    deleteRole: deleteRoleMutation.mutateAsync,
    isCreating: createRoleMutation.isLoading,
    isUpdating: updateRoleMutation.isLoading,
    isDeleting: deleteRoleMutation.isLoading
  };
};